module.exports = __webpack_public_path__ + "citco.f342000cf716c5d66b3c92386603eb1a.svg";